import { render, staticRenderFns } from "./MyTicketsPage.vue?vue&type=template&id=d74857f8"
import script from "./MyTicketsPage.vue?vue&type=script&lang=js"
export * from "./MyTicketsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports